import { render, staticRenderFns } from "./EstateComLayout.vue?vue&type=template&id=085d1765&scoped=true&"
import script from "./EstateComLayout.vue?vue&type=script&lang=js&"
export * from "./EstateComLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085d1765",
  null
  
)

export default component.exports